export default "__VITE_ASSET__8cd2dd5d__"